import { Type } from '@angular/core';
import { WidgetBase } from './widget-base';

export type WidgetLoader = () => Promise<Type<WidgetBase<any>>>;

/**
 * Mapa `identificador` (cadastrado em /administracao/widgets) → componente do widget,
 * carregado sob demanda (FRONTEND.md §4.5). A chave deve ser exatamente o identificador.
 *
 * Identificador sem entrada aqui é exibido como "Widget indisponível".
 */
export const WIDGET_REGISTRY: Record<string, WidgetLoader> = {
  // Baixa de consumíveis (ROLE_INTEG_MOVIMEN_BAIXA) — /consumiveis/dashboard
  'integ-movimen-baixa.indicador': () =>
    import('../integ-movimen-baixa/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-movimen-baixa.status': () =>
    import('../integ-movimen-baixa/status/status.component').then(m => m.StatusComponent),
  'integ-movimen-baixa.evolucao': () =>
    import('../integ-movimen-baixa/evolucao/evolucao.component').then(m => m.EvolucaoComponent),
  'integ-movimen-baixa.erros': () =>
    import('../integ-movimen-baixa/erros/erros.component').then(m => m.ErrosComponent),
  'integ-movimen-baixa.materiais': () =>
    import('../integ-movimen-baixa/materiais/materiais.component').then(m => m.MateriaisComponent),
  'integ-movimen-baixa.centros-custo': () =>
    import('../integ-movimen-baixa/centros-custo/centros-custo.component').then(m => m.CentrosCustoComponent),
  'integ-movimen-baixa.tentativas': () =>
    import('../integ-movimen-baixa/tentativas/tentativas.component').then(m => m.TentativasComponent),
  'integ-movimen-baixa.saude': () =>
    import('../integ-movimen-baixa/saude/saude.component').then(m => m.SaudeComponent),

  // Cadastro de municípios (ROLE_INTEG_MESTRES_MUN) — /municipios/dashboard
  'integ-mestres-mun.completude': () =>
    import('../integ-mestres-mun/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-mun.indicador': () =>
    import('../integ-mestres-mun/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-mun.pendencias': () =>
    import('../integ-mestres-mun/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-mun.erros': () =>
    import('../integ-mestres-mun/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-mun.evolucao': () =>
    import('../integ-mestres-mun/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Cadastro de depósitos (ROLE_INTEG_MESTRES_DEPOSITO) — /depositos/dashboard
  'integ-mestres-deposito.completude': () =>
    import('../integ-mestres-deposito/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-deposito.indicador': () =>
    import('../integ-mestres-deposito/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-deposito.pendencias': () =>
    import('../integ-mestres-deposito/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-deposito.erros': () =>
    import('../integ-mestres-deposito/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-deposito.evolucao': () =>
    import('../integ-mestres-deposito/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Cadastro de equipamentos — /equipamentos/dashboard
  'integ-mestres-equipamentos.completude': () =>
    import('../integ-mestres-equipamentos/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-equipamentos.indicador': () =>
    import('../integ-mestres-equipamentos/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-equipamentos.pendencias': () =>
    import('../integ-mestres-equipamentos/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-equipamentos.erros': () =>
    import('../integ-mestres-equipamentos/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-equipamentos.evolucao': () =>
    import('../integ-mestres-equipamentos/evolucao/evolucao.component').then(m => m.EvolucaoComponent),
  'integ-mestres-equipamentos.qualidade': () =>
    import('../integ-mestres-equipamentos/qualidade/qualidade.component').then(m => m.QualidadeComponent),

  // Cadastro de materiais — /materiais/dashboard
  'integ-mestres-mat.completude': () =>
    import('../integ-mestres-mat/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-mat.indicador': () =>
    import('../integ-mestres-mat/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-mat.pendencias': () =>
    import('../integ-mestres-mat/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-mat.erros': () =>
    import('../integ-mestres-mat/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-mat.evolucao': () =>
    import('../integ-mestres-mat/evolucao/evolucao.component').then(m => m.EvolucaoComponent),
  'integ-mestres-mat.qualidade': () =>
    import('../integ-mestres-mat/qualidade/qualidade.component').then(m => m.QualidadeComponent),
  'integ-mestres-mat.grupos': () =>
    import('../integ-mestres-mat/grupos/grupos.component').then(m => m.GruposComponent),

  // Cadastro de fornecedores — /fornecedores/dashboard
  'integ-mestres-fornec.completude': () =>
    import('../integ-mestres-fornec/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-fornec.indicador': () =>
    import('../integ-mestres-fornec/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-fornec.pendencias': () =>
    import('../integ-mestres-fornec/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-fornec.erros': () =>
    import('../integ-mestres-fornec/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-fornec.evolucao': () =>
    import('../integ-mestres-fornec/evolucao/evolucao.component').then(m => m.EvolucaoComponent),
  'integ-mestres-fornec.qualidade': () =>
    import('../integ-mestres-fornec/qualidade/qualidade.component').then(m => m.QualidadeComponent),

  // Cadastro de centros de custo — /centrodecustos/dashboard
  'integ-mestres-centrocustos.completude': () =>
    import('../integ-mestres-centrocustos/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-centrocustos.indicador': () =>
    import('../integ-mestres-centrocustos/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-centrocustos.pendencias': () =>
    import('../integ-mestres-centrocustos/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-centrocustos.erros': () =>
    import('../integ-mestres-centrocustos/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-centrocustos.evolucao': () =>
    import('../integ-mestres-centrocustos/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Cadastro de contas contábeis — /contascontabeis/dashboard
  'integ-mestres-contascontab.completude': () =>
    import('../integ-mestres-contascontab/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-contascontab.indicador': () =>
    import('../integ-mestres-contascontab/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-contascontab.pendencias': () =>
    import('../integ-mestres-contascontab/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-contascontab.erros': () =>
    import('../integ-mestres-contascontab/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-contascontab.evolucao': () =>
    import('../integ-mestres-contascontab/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Cadastro de unidades de medida (ROLE_INTEG_MESTRES_UM) — /unidademedidas/dashboard
  'integ-mestres-um.completude': () =>
    import('../integ-mestres-um/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-mestres-um.indicador': () =>
    import('../integ-mestres-um/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-mestres-um.pendencias': () =>
    import('../integ-mestres-um/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-mestres-um.erros': () =>
    import('../integ-mestres-um/erros/erros.component').then(m => m.ErrosComponent),
  'integ-mestres-um.evolucao': () =>
    import('../integ-mestres-um/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Balança / pesagem de remessas (ROLE_INTEG_MOVIMEN_BALANCA) — /pesagem-balanca/dashboard
  'integ-movimen-balanca.resumo': () =>
    import('../integ-movimen-balanca/resumo/resumo.component').then(m => m.ResumoComponent),
  'integ-movimen-balanca.indicador': () =>
    import('../integ-movimen-balanca/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-movimen-balanca.distribuicao': () =>
    import('../integ-movimen-balanca/distribuicao/distribuicao.component').then(m => m.DistribuicaoComponent),
  'integ-movimen-balanca.evolucao': () =>
    import('../integ-movimen-balanca/evolucao/evolucao.component').then(m => m.EvolucaoComponent),
  'integ-movimen-balanca.mapa-calor': () =>
    import('../integ-movimen-balanca/mapa-calor/mapa-calor.component').then(m => m.MapaCalorComponent),
  'integ-movimen-balanca.produtos': () =>
    import('../integ-movimen-balanca/produtos/produtos.component').then(m => m.ProdutosComponent),
  'integ-movimen-balanca.erros': () =>
    import('../integ-movimen-balanca/erros/erros.component').then(m => m.ErrosComponent),

  // Fluxo de caixa (ROLE_INTEG_MOVIMEN_FLUXOCAIXA) — /fluxocaixa/dashboard
  'integ-movimen-fluxocaixa.resumo': () =>
    import('../integ-movimen-fluxocaixa/resumo/resumo.component').then(m => m.ResumoComponent),
  'integ-movimen-fluxocaixa.receita-despesa': () =>
    import('../integ-movimen-fluxocaixa/receita-despesa/receita-despesa.component').then(m => m.ReceitaDespesaComponent),
  'integ-movimen-fluxocaixa.ranking': () =>
    import('../integ-movimen-fluxocaixa/ranking/ranking.component').then(m => m.RankingComponent),
  'integ-movimen-fluxocaixa.completude': () =>
    import('../integ-movimen-fluxocaixa/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-movimen-fluxocaixa.indicador': () =>
    import('../integ-movimen-fluxocaixa/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-movimen-fluxocaixa.pendencias': () =>
    import('../integ-movimen-fluxocaixa/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-movimen-fluxocaixa.erros': () =>
    import('../integ-movimen-fluxocaixa/erros/erros.component').then(m => m.ErrosComponent),
  'integ-movimen-fluxocaixa.evolucao': () =>
    import('../integ-movimen-fluxocaixa/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Custos calculados (ROLE_INTEG_MOVIMEN_FLUXOCAIXA) — /custoscalculados/dashboard
  'integ-movimen-fluxocaixa.custos-resumo': () =>
    import('../integ-movimen-fluxocaixa/custos-resumo/custos-resumo.component').then(m => m.CustosResumoComponent),
  'integ-movimen-fluxocaixa.custos-serie': () =>
    import('../integ-movimen-fluxocaixa/custos-serie/custos-serie.component').then(m => m.CustosSerieComponent),
  'integ-movimen-fluxocaixa.custos-ranking': () =>
    import('../integ-movimen-fluxocaixa/custos-ranking/custos-ranking.component').then(m => m.CustosRankingComponent),
  'integ-movimen-fluxocaixa.custos-completude': () =>
    import('../integ-movimen-fluxocaixa/custos-completude/custos-completude.component').then(m => m.CustosCompletudeComponent),
  'integ-movimen-fluxocaixa.custos-indicador': () =>
    import('../integ-movimen-fluxocaixa/custos-indicador/custos-indicador.component').then(m => m.CustosIndicadorComponent),
  'integ-movimen-fluxocaixa.custos-pendencias': () =>
    import('../integ-movimen-fluxocaixa/custos-pendencias/custos-pendencias.component').then(m => m.CustosPendenciasComponent),
  'integ-movimen-fluxocaixa.custos-erros': () =>
    import('../integ-movimen-fluxocaixa/custos-erros/custos-erros.component').then(m => m.CustosErrosComponent),
  'integ-movimen-fluxocaixa.custos-evolucao': () =>
    import('../integ-movimen-fluxocaixa/custos-evolucao/custos-evolucao.component').then(m => m.CustosEvolucaoComponent),

  // Custos (ROLE_INTEG_MOVIMEN_CUSTO) — /custos/dashboard
  'integ-movimen-custo.competencias': () =>
    import('../integ-movimen-custo/competencias/competencias.component').then(m => m.CompetenciasComponent),
  'integ-movimen-custo.resumo': () =>
    import('../integ-movimen-custo/resumo/resumo.component').then(m => m.ResumoComponent),
  'integ-movimen-custo.serie': () =>
    import('../integ-movimen-custo/serie/serie.component').then(m => m.SerieComponent),
  'integ-movimen-custo.ranking': () =>
    import('../integ-movimen-custo/ranking/ranking.component').then(m => m.RankingComponent),
  'integ-movimen-custo.completude': () =>
    import('../integ-movimen-custo/completude/completude.component').then(m => m.CustoCompletudeComponent),
  'integ-movimen-custo.indicador': () =>
    import('../integ-movimen-custo/indicador/indicador.component').then(m => m.CustoIndicadorComponent),
  'integ-movimen-custo.pendencias': () =>
    import('../integ-movimen-custo/pendencias/pendencias.component').then(m => m.CustoPendenciasComponent),
  'integ-movimen-custo.erros': () =>
    import('../integ-movimen-custo/erros/erros.component').then(m => m.CustoErrosComponent),
  'integ-movimen-custo.evolucao': () =>
    import('../integ-movimen-custo/evolucao/evolucao.component').then(m => m.CustoEvolucaoComponent),

  // Produção industrial (ROLE_INTEG_MOVIMEN_PRODUCAOIND) — /producoes/dashboard
  'integ-movimen-producaoind.resumo': () =>
    import('../integ-movimen-producaoind/resumo/resumo.component').then(m => m.ResumoComponent),
  'integ-movimen-producaoind.producao': () =>
    import('../integ-movimen-producaoind/producao/producao.component').then(m => m.ProducaoComponent),
  'integ-movimen-producaoind.ranking': () =>
    import('../integ-movimen-producaoind/ranking/ranking.component').then(m => m.RankingComponent),
  'integ-movimen-producaoind.completude': () =>
    import('../integ-movimen-producaoind/completude/completude.component').then(m => m.CompletudeComponent),
  'integ-movimen-producaoind.indicador': () =>
    import('../integ-movimen-producaoind/indicador/indicador.component').then(m => m.IndicadorComponent),
  'integ-movimen-producaoind.pendencias': () =>
    import('../integ-movimen-producaoind/pendencias/pendencias.component').then(m => m.PendenciasComponent),
  'integ-movimen-producaoind.erros': () =>
    import('../integ-movimen-producaoind/erros/erros.component').then(m => m.ErrosComponent),
  'integ-movimen-producaoind.evolucao': () =>
    import('../integ-movimen-producaoind/evolucao/evolucao.component').then(m => m.EvolucaoComponent),

  // Visão global de todas as interfaces (ROLE_INTEG) — lê o /dashboard de cada serviço
  'integ.status-integracoes': () =>
    import('../integ/status-integracoes/status-integracoes.component').then(m => m.StatusIntegracoesComponent),

  // Exemplos fictícios (dados fixos), para testes do dashboard
  'integ.exemplo-vendas-mensais': () =>
    import('../integ/exemplo-vendas-mensais/exemplo-vendas-mensais.component').then(m => m.ExemploVendasMensaisComponent),
  'integ.exemplo-status-integracoes': () =>
    import('../integ/exemplo-status-integracoes/exemplo-status-integracoes.component').then(m => m.ExemploStatusIntegracoesComponent),
  'integ.exemplo-producao-turno': () =>
    import('../integ/exemplo-producao-turno/exemplo-producao-turno.component').then(m => m.ExemploProducaoTurnoComponent),
};
